// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608050912/js/" + chunkId + "." + {"44":"2788d3aa","225":"5c93dc73","481":"4729f220","486":"fb98ca83","770":"384b24d2"}[chunkId] + ".0.23407548817486157.chunk.js";
};